import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const userRegistration = (data) => api.post(url.USER_REGISTER, data);

// Login
export const userLogin = (data) => api.post(url.USER_LOGIN, data);

// Get User Detail
export const getUserDetail = () => api.get(url.USER_DETAILS);

//Refresh Token
export const getRefreshToken = (data) => api.post(url.REFRESH_TOKEN, data);

// Save Notification Token
export const saveUserNotificationToken = (data) => api.post(url.SAVE_NOTIFICATION_TOKEN, data);
//Forgot Password
export const userForgotPassword = (data) => api.post(url.FORGOT_PASSWORD, data);

//Verify Code
export const useVerifyCode = (data) => api.post(url.VERIFY_CODE, data);

//Reset New Password
export const userResetPassword = (data) => api.post(url.RESET_PASSWORD, data);

//Update Profile pic
export const updateUserProfilePic = (data) =>
  api.put(url.UPDATE_PROFILE_PIC, data);

//Update Profile Details
export const updateUserProfileDetails = (data) =>
  api.patch(url.UPDATE_PROFILE_DETAILS, data);

//Change Password
export const changeUserPassword = (data) => api.put(url.CHANGE_PASSWORD, data);

// ------------------------------------------------------------------------------------------------------------------------------------------


export const getVehicleListApi = (currentPage, pageSize, searchText) =>
  api.get(
    `${url.VEHICLE_LIST}?page=${currentPage}&page_size=${pageSize}&search=${searchText}`
  );

export const getVehicleByIdApi = (id) => api.get(`${url.VEHICLE_BY_ID}/${id}`);

export const getVehicleTypeApi = () => api.get(url.VEHICLE_TYPE);

export const createVehicleApi = (data) =>
  api.post(url.VEHICLE_CREATE_API, data);

export const updateVehicleApi = (id, data) =>
  api.patch(`${url.VEHICLE_UPDATE_API}/${id}/`, data);

export const deleteVehicleApi = (id) =>
  api.delete(`${url.VEHICLE_DELETE_API}/${id}/`);

// ------------------------------------------------------------------------------------------------------------------------------------------

export const getAllTripsApi = (currentPage, pageSize, searchText, date_filter, from_time, to_time) =>
  api.get(
    `${url.GET_TRIPS}?page=${currentPage}&page_size=${pageSize}&search=${searchText}&date_filter=${date_filter}&from_time=${from_time}&to_time=${to_time}`
  );

export const getTripsByIdApi = (id) => api.get(`${url.GET_TRIPS_BY_ID}/${id}/`);

export const createTripsApi = (data) => api.post(url.CREATE_TRIPS, data);

export const createTripsUsingExcelApi = (data) =>
  api.post(url.CREATE_TRIPS_USING_EXCEL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const assignTripsApi = (id, data) =>
  api.patch(`${url.ASSIGN_TRIPS}/${id}/`, data);

export const updateTripsApi = (id, data) =>
  api.patch(`${url.UPDATE_TRIPS}/${id}/`, data);

export const uploadTripsApi = (data) => api.post(url.UPLOAD_TRIPS, data);

export const deleteTripsApi = (id) => api.delete(`${url.DELETE_TRIP}/${id}/`);

// ------------------------------------------------------------------------------------------------------------------------------------------

export const getAllMaintenanceApi = (currentPage, pageSize, searchText) =>
  api.get(
    `${url.GET_MAINTENANCE}?page=${currentPage}&page_size=${pageSize}&search=${searchText}`
  );

export const createMaintenanceApi = (data) =>
  api.post(url.CREATE_MAINTENANCE, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const getMaintenanceByIdApi = (id) =>
  api.get(`${url.MAINTENANCE_BY_ID}/${id}/`);

export const updateMaintenanceApi = (id, data) =>
  api.patch(`${url.UPDATE_MAINTENANCE}/${id}/`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const deleteMaintenanceApi = (id) =>
  api.delete(`${url.DELETE_MAINTENANCE}/${id}/`);


export const deleteMaintenanceImageApi = (id) =>
  api.delete(`${url.DELETE_IMAGE}/${id}/`);
// ------------------------------------------------------------------------------------------------------------------------------------------

export const getAllInsurancesApi = (currentPage, pageSize, searchText) =>
  api.get(
    `${url.GET_INSURANCE}?page=${currentPage}&page_size=${pageSize}&search=${searchText}`
  )

export const createInsurancesApi = (data) => api.post(url.CREATE_INSURANCE, data,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
);

export const getInsurancesByIdApi = (id) => api.get(`${url.INSURANCE_BY_ID}/${id}/`);

export const updateInsurancesApi = (id, data) =>
  api.patch(`${url.UPDATE_INSURANCE}/${id}/`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const deleteInsurancesApi = (id) => api.delete(`${url.DELETE_INSURANCE}/${id}/`);

export const deleteInsurancesImageApi = (id) => api.delete(`${url.DELETE_INSURANCE_IMAGE}/${id}/`);
// ------------------------------------------------------------------------------------------------------------------------------------------

export const getAllRolesApi = (currentPage, pageSize, searchText) =>
  api.get(
    `${url.GET_ROLES}?page=${currentPage}&page_size=${pageSize}&search=${searchText}`
  );

export const createRolesApi = (data) => api.post(url.CREATE_ROLES, data);

export const getRoleByIdApi = (id) => api.get(`${url.ROLE_BY_ID}/${id}/`);

export const updateRoleApi = (id, data) =>
  api.patch(`${url.UPDATE_ROLE}/${id}/`, data);

export const deleteRoleApi = (id) => api.delete(`${url.DELETE_ROLE}/${id}/`);

export const getAllPermissionsApi = () => api.get(url.GET_PERMISSIONS);

// ------------------------------------------------------------------------------------------------------------------------------------------

export const getAllSalaryApi = (currentPage, pageSize, search) =>
  api.get(
    `${url.GET_SALARY}?page=${currentPage}&page_size=${pageSize}&search=${search}`
  );

export const createSalaryApi = (data) => api.post(url.CREATE_SALARY, data);

export const getSalaryByIdApi = (id) => api.get(`${url.SALARY_BY_ID}/${id}/`);

export const updateSalaryApi = (id, data) => api.patch(`${url.UPDATE_SALARY}/${id}/`, data);

export const deleteSalaryApi = (id) => api.delete(`${url.DELETE_SALARY}/${id}/`);

// ------------------------------------------------------------------------------------------------------------------------------------------

export const getAllUsersApi = (currentPage, pageSize, searchText) =>
  api.get(
    `${url.GET_USERS}?page=${currentPage}&page_size=${pageSize}&search=${searchText}`
  );

export const createUserApi = (data) => api.post(url.CREATE_USER, data);

export const getUserByIdApi = (id) => api.get(`${url.USER_BY_ID}/${id}/`);

export const updateUserApi = (id, data) =>
  api.patch(`${url.UPDATE_USER}/${id}/`, data);

export const deleteUserApi = (id) => api.delete(`${url.DELETE_USER}/${id}/`);


// ------------------------------------------------------------------------------------------------------------------------------------------


export const getAdminDashboardApi = () => api.get(url.GET_ADMIN_DASHBOARD_DETAILS);


// ------------------------------------------------------------------------------------------------------------------------------------------

export const getTripDashboardApi = () => api.get(url.GET_TRIP_DASHBOARD_DETAILS);

export const getTrackRealTimeTripApi = (from, to, id) => api.get(`${url.GET_TRACK_REAL_TIME_TRIP}/?from_time=${from}&to_time=${to}&truck_id=${id}`);

// ------------------------------------------------------------------------------------------------------------------------------------------

export const getAdminRevenus_ExpensesApi = () => api.get(url.GET_REVENUE_EXPENSES);


// ------------------------------------------------------------------------------------------------------------------------------------------

export const getTripDetailsInRealTime = () => api.get(url.GET_TRIP_LIST_DETAILS_REAL_TIME);



// ------------------------------------------------------------------------------------------------------------------------------------------


export const getDriverDetailsApi = (id) => api.get(`${url.GET_DRIVER_BY_ID}/${id}/`);

export const updateDriverApi = (id, data) =>
  api.patch(`${url.UPDATE_DRIVER}/${id}/`, data);


export const deleteDriverApi = (id) => api.delete(`${url.DELETE_DRIVER}/${id}/`);

export const getAllDriverApi = (currentPage, pageSize, searchText) =>
  api.get(
    `${url.GET_LIST_DRIVER}?page=${currentPage}&page_size=${pageSize}&search=${searchText}`
  );

export const createDriverApi = (data) => api.post(url.CREATE_DRIVER, data);




// ------------------------------------------------------------------------------------------------------------------------------------------


export const getMaintenanceCategoryApi = (currentPage, pageSize, searchText) =>
  api.get(
    `${url.GET_MAINTENANCE_CATEGORY}?page=${currentPage}&page_size=${pageSize}&search=${searchText}`
  );

export const createMaintenanceCategoryApi = (data) =>
  api.post(url.CREATE_MAINTENANCE_CATEGORY, data);

export const getMaintenanceCategoryByIdApi = (id) =>
  api.get(`${url.GET_MAINTENANCE_CATEGORY_BY_ID}/${id}/`);


export const updateMaintenanceCategoryApi = (id, data) =>
  api.patch(`${url.UPDATE_MAINTENANCE_CATEGORY}/${id}/`, data);

export const deleteMaintenanceCategoryApi = (id) =>
  api.delete(`${url.DELETE_MAINTENANCE_CATEGORY}/${id}/`);



// ------------------------------------------------------------------------------------------------------------------------------------------


export const getInsuranceCategoryAPi = (currentPage, pageSize, searchText) =>
  api.get(
    `${url.GET_INSURANCE_CATEGORY}?page=${currentPage}&page_size=${pageSize}&search=${searchText}`
  );

export const createInsuranceCategoryApi = (data) =>
  api.post(url.CREATE_INSURANCE_CATEGORY, data);


export const getInsuranceCategoryByIdApi = (id) =>
  api.get(`${url.GET_INSURANCE_CATEGORY_BY_ID}/${id}/`);

export const updateInsuranceCategoryApi = (id, data) =>
  api.patch(`${url.UPDATE_INSURANCE_CATEGORY}/${id}/`, data);

export const deleteInsuranceCategoryApi = (id) =>
  api.delete(`${url.DELETE_INSURANCE_CATEGORY}/${id}/`);



// ------------------------------------------------------------------------------------------------------------------------------------------


export const getVehicleCategory = (currentPage, pageSize, searchText) =>
  api.get(
    `${url.GET_VEHICLE_CATEGORY}?page=${currentPage}&page_size=${pageSize}&search=${searchText}`
  );


export const createVehicleCategoryApi = (data) =>
  api.post(url.CREATE_VEHICLE_CATEGORY, data);

export const getVehicleCategoryByIdApi = (id) =>
  api.get(`${url.GET_VEHICLE_CATEGORY_BY_ID}/${id}/`);

export const updateVehicleCategoryApi = (id, data) =>
  api.patch(`${url.UPDATE_VEHICLE_CATEGORY}/${id}/`, data);

export const deleteVehicleCategoryApi = (id) =>
  api.delete(`${url.DELETE_VEHICLE_CATEGORY}/${id}/`);